import {InspectFaModel} from '../../../generated/core';
import {MocksServerConfig} from '@volkswagen-onehub/fetch-json';

export function getMocksServerConfig(
    inspectFaModel?: InspectFaModel
): MocksServerConfig | undefined {
    return inspectFaModel &&
        inspectFaModel.onehubMockUser &&
        inspectFaModel.onehubMockPassword
        ? {
              baseUrl: 'https://mocks.onehub.feature-app.io',
              auth: {
                  username: inspectFaModel.onehubMockUser,
                  password: inspectFaModel.onehubMockPassword
              }
          }
        : undefined;
}
